import { usePresentationContext } from '../../legacy-context/presentationContext';
import { LivePresentationDataHandler } from './LivePresentationDataHandler';
import { ViewOnlyPresentationDataHandler } from './ViewOnlyPresentationDataHandler';

export function QuizChoicesPresentationDataHandler() {
  const { useConfig } = usePresentationContext();
  const { mode } = useConfig();

  if (mode !== 'live') {
    return <ViewOnlyPresentationDataHandler />;
  }

  return <LivePresentationDataHandler />;
}
